var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$root.isIE)?_c('div',{staticClass:"v-align",attrs:{"id":"ie-error"},domProps:{"innerHTML":_vm._s(_vm.$t('_ie_not_allowed'))}}):_vm._e(),_c('div',[_c('bandeau')],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }